import {SettingsParamsType} from '../../types/createStylesParams'

import {displaySettingsParams, DisplaySettingsParams} from './Settings/Tabs/Display/settingsParams'
import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'

export type SettingsParams = DisplaySettingsParams & TextsSettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...displaySettingsParams,
  ...textsSettingsParams,
}

export default settingsParams
